"use client";

import { snackbarStore } from "@/atoms-store/snackbar-store";
import Snackbar from "@/common/components/snackbar/snackbar";
import AuthNGaurd from "@/common/context/auth-context";
import { NextUIProvider } from "@nextui-org/system";
import { Provider } from 'jotai';
import { ThemeProvider as NextThemesProvider } from "next-themes";
import { ThemeProviderProps } from "next-themes/dist/types";
import { useRouter } from 'next/navigation';
import { ReactNode, Suspense } from "react";
import { Toaster } from "sonner";
import Loading from "./loading";


export interface ProvidersProps {
	children: ReactNode;
	themeProps?: ThemeProviderProps;
}

export function Providers({ children, themeProps }: ProvidersProps) {
	const router = useRouter();

	return (
		<NextUIProvider navigate={router.push}>
			<NextThemesProvider {...themeProps}>
				<Provider store={snackbarStore}>
					<Snackbar />
					<Toaster richColors position="top-right" />
					<Suspense fallback={<Loading />}>
						<AuthNGaurd>
							{children}
						</AuthNGaurd>
					</Suspense>
				</Provider>
			</NextThemesProvider>
		</NextUIProvider>
	);
}
